import 'babel-polyfill';
import Vue from 'vue';
import ComponentTranslate from '@/libs/componentTranslatePlugin';
import VueCookies from 'vue-cookies';
import FlagIcon from 'vue-flag-icon'
import Hub from '@/libs/signalR/signalr';
import { HubConnectionState } from '@microsoft/signalr';
import { RunStates } from '@/libs/signalR/vuexStore/store/state';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import { EventBus, EVENTS } from './libs/eventBus';
import Api from './api'

Vue.config.productionTip = false;
Vue.use(VueCookies);
// set default config
Vue.$cookies.config('30d');
let hub = new Hub(store, Vue.http, i18n);
let api = new Api(store, hub, i18n)

const isAuthenticated = function (myStore, myCookies) {
  const cookie = myCookies.get('gdpr');

  if (!cookie) {
    // Clear the current state, if the cookie is not allowed
    myStore.commit('clearState');
  }

  return myStore.getters.token() != null;
};

const isBlocked = function (myStore, myHub) {
  const { runState } = myStore.state.signalR;
  const runInfo = myStore.state?.runInfo;
  if (myHub.connection && myHub.connection.state === HubConnectionState.Connected) {
    return runState === RunStates.RunEdit;
  }
  return runInfo?.runInformation?.runState < 2 || runInfo?.runInformation?.runState > 5;
}

// Setup route guard
router.beforeEach((to, from, next) => {
  const authorized = isAuthenticated(store, Vue.$cookies);
  if (to.meta.requiresAuthentication && !authorized) {
    if (hub.connection && hub.connection.state !== HubConnectionState.Disconnected) hub.close();
    next({ name: 'login' });
    return;
  }
  if (authorized && (!hub.connection || hub.connection.state !== HubConnectionState.Connected)) {
    hub.setup()();
  }
  if (authorized && isBlocked(store, hub) && !to.meta.isBlocker) {
    console.log('redirect to blocker')
    next({ name: 'blocker' })

  } else {
    next();
  }
});

// remove that eventbus thingy as fast as possible
router.afterEach((to, from, next) => {
  EventBus.$emit(EVENTS.ROUTE_PUSHED);
});

Vue.use(FlagIcon);
Vue.use(ComponentTranslate);

new Vue({
  router,
  store,
  vuetify,
  api,
  hub,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
// default locale 'de' set
i18n.locale = 'de'
